import { Product } from '@setvi/shared/interfaces';
import { getStock } from '../components';

export const filterByManufacturer = (val: string[], product: Product) => {
  if (!val.length) return true;

  return val.some(i => i === product.vendor?.name);
};

export const filterByStock = (val: boolean | null, product: Product) => {
  if (val === null) return true;

  const stock = getStock(product.inventory);

  return val ? stock > 0 : stock === 0;
};

export const filterByCost = (val: [number, number] | [], product: Product) => {
  if (!val.length || !product.cost) return true;

  return product.cost >= val[0] && product.cost <= val[1];
};

export const filterByStockInfo = (val: boolean | null, product: Product) => {
  if (val === null) return true;

  const warehousesWithStock = product?.stockInfo?.warehouses.filter(
    warehouse => warehouse.stock
  );

  const stock =
    product?.stockInfo?.allWarehouses || warehousesWithStock?.length > 0;

  return val ? stock : !stock;
};
